import { setLocation } from 'bv-helpers/location';

export default () => {
  window.history.replaceState({}, 'back', '/bv_cashier/overview?first_modal=true');
  setLocation('/preferences/edit?show_success_message=true&first_modal=false');
};
